import { memo, useContext, useEffect } from "react";
import { ErrorMessage } from "@hookform/error-message";
import { FormProvider, useForm } from "react-hook-form";
import { DynamicFieldData } from "./dynamic-control-types";
import { DynamicControl } from "./DynamicControl";
import { ObjectContext } from "@providers/ObjectProvider";
import { Box } from "@mui/joy";

interface FormProps {
  fields: DynamicFieldData[];
  children: any;
}

export const Form = memo(function ({ fields, children, onSubmit, initialData = null, style = {} }: FormProps) {
  const data = useContext(ObjectContext);

  // TODO: check when data changes and update default values if they aren't dirty

  const formMethods = useForm({
    defaultValues: initialData ? initialData : async () => data,
  });

  /*
  useEffect(() => {
    // if empty, set it
    for(const key in initialData) {
      if(!formMethods.watch(key)) {
        formMethods.setValue(key, initialData[key]);
      }
    }
  }, [initialData]);
  */

  const {
    handleSubmit,
    formState: { isSubmitting, errors }
  } = formMethods;

  // console.debug('Form was rendered at', new Date().toLocaleTimeString());

  return (
    <form onSubmit={handleSubmit(onSubmit)} style={style}>
      <FormProvider {...formMethods}>
        {/* this hacky thing stops you from editing while saving */}
        {/* {isSubmitting && <Box sx={{position: 'absolute', top: 0, right: 0, bottom: 0, left: 0, zIndex: '9999', bgcolor: 'transparent'}}/>} */}
        {children}
        {/*
        {fields.map((d, i) => (
          <div key={i}>
            <label htmlFor={d.fieldName}>{d.label}</label>

            <DynamicControl {...d} />

            <ErrorMessage errors={errors} name={d.fieldName} />
          </div>
        ))}
        */}
      </FormProvider>
    </form>
  );
});
